import React, { Component } from "react";
import PropTypes from "prop-types";
import { StyledAiRow } from "../_components/styled/ai/styledAi";
import Format from "string-format";
import { AI_DOCUMENT, AI_DOCUMENT_PATH, DOCUMENTS, FOLDER_CONTENTS_PATH } from "../_utils/routes";
import {
  TldrCheckbox,
  TldrNewFolderDialog,
} from "../_components/styled/home/statelessView";
import {
  createNewFolder,
  moveToFolder,
  removeFolderContent,
  selectCard,
  unSelectCard,
} from "../_actions/folderActions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  closeSlider,
  deleteUserAssets,
  openAdvancedSettings,
  resetPage,
} from "../_actions/sidebarSliderActions";
import axios from "axios";
import {
  TldrConfirmationModal,
  TldrUserInfoView,
} from "../_components/common/statelessView";
import {
  ADVANCED_AI_EDITOR_PANEL,
  ADVANCED_AI_RESULTS,
} from "../_components/details/constants";
import { getDocuments, resetDocument } from "../_actions/aiDocumentActions";
import { Divider, HStack, Tooltip } from "@chakra-ui/react";
import {
  FaAlignLeft,
  FaTrash,
  FaEllipsisV,
  FaArrowAltCircleUp,
  FaArrowAltCircleDown,
} from "react-icons/fa";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Icon,
} from "@chakra-ui/react";
import { ContentTypes } from "../_utils/constants";
import TldrMoveToFolderModal from "../_components/home/TldrMoveToFolderModal";
import { withTranslation } from "react-i18next";

class AIDocument extends Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props);

    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);

    this.state = {
      isHovering: false,
      isChecked: false,
      showConfirmationModal: false,
      inProgress: false,
      showMoveToFolderModal: false,
      showNewFolderModal: false,
      showRemoveFromFolderModal: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { result } = this.props;
    const resultId = result.content_id || result.id;

    if (this.props !== prevProps) {
      this.setState({
        isChecked: this.props.selectedCards.find(
          (item) => item.content_id === resultId
        ),
      });
    }
  }

  handleOnDocumentClick = () => {
    const {
      result,
      location,
      selectedCards,
      history,
      resetDocument,
      openAdvancedSettings,
      match,
      closeSlider,
    } = this.props;
    const { isChecked } = this.state;
    const resultId = result.content_id || result.id;

    if (selectedCards.length > 0) {
      this.onDocumentClickHandler(!isChecked);
      return;
    }

    if (location.pathname === DOCUMENTS) {
      history.push(Format(AI_DOCUMENT, resultId));
    } else if (match.path === FOLDER_CONTENTS_PATH) {
      history.push(Format(AI_DOCUMENT, resultId));
    } else if (match.path === AI_DOCUMENT_PATH) {
      return;
    } else {
      resetDocument();
      closeSlider();
      openAdvancedSettings(
        ADVANCED_AI_EDITOR_PANEL,
        ADVANCED_AI_RESULTS,
        resultId
      );
    }
  };

  handleMoveToFolder = (id, name) => {
    const { result } = this.props;
    const resultId = result.content_id || result.id;
    const payload = {
      content_ids: [resultId],
    };

    this.props.resetPage("");

    this.props
      .moveToFolder(payload, id, name, this.signal.token)
      .then((res) => {
        this.setState(
          {
            showMoveToFolderModal: false,
            inProgress: false,
          },
          () => {
            if (this.props.onActionComplete) {
              this.props.onActionComplete();
            } else {
              this.props.getDocuments(this.props, "searchTerm", this.signal);
            }
          }
        );
      })
      .catch((error) => {
        this.setState({
          showMoveToFolderModal: false,
          inProgress: false,
        });
      });
  };

  handleCreateNewFolder = (name) => {
    this.props
      .createNewFolder(name, this.signal.token, this.props)
      .then((folder) => {
        this.setState(
          {
            showNewFolderModal: false,
            inProgress: false,
          },
          () => {
            this.handleMoveToFolder(folder.id, folder.name);
          }
        );
      })
      .catch(() => {
        this.setState({
          showNewFolderModal: false,
          inProgress: false,
        });
      });
  };

  handleRemoveFromFolder = () => {
    const { result, currentFolderId } = this.props;
    const resultId = result.content_id || result.id;
    const payload = {
      remove_content_ids: [resultId],
    };

    this.props.resetPage("");

    this.props
      .removeFolderContent(currentFolderId, payload, this.signal.token)
      .then((res) => {
        this.setState(
          {
            showRemoveFromFolderModal: false,
            inProgress: false,
          },
          () => {
            if (this.props.onActionComplete) {
              this.props.onActionComplete();
            } else {
              this.props.getDocuments(this.props, "searchTerm", this.signal);
            }
          }
        );
      })
      .catch(() => {
        this.setState({
          showRemoveFromFolderModal: false,
          inProgress: false,
        });
      });
  };

  render() {
    const {
      result,
      enableCardSelection,
      workspacePermissionChecks,
      authUser,
      currentFolderId,
      showRemoveFromFolder,
      showExtraOptions,
      t,
    } = this.props;
    const {
      isHovering,
      isChecked,
      showConfirmationModal,
      inProgress,
      showMoveToFolderModal,
      showNewFolderModal,
      showRemoveFromFolderModal,
    } = this.state;
    const { canViewAIDocument, canDeleteAIDocument } =
      workspacePermissionChecks;
    const resultId = result.content_id || result.id;
    const resultName = result.content_name || result.title;

    const isDocumentCreator = result?.creator?.id === authUser.pk;
    return (
      <div key={`${resultId}`}>
        <StyledAiRow
          key={`row_${resultId}`}
          onClick={(e) => {
            if (!canViewAIDocument) {
              return;
            }
            this.handleOnDocumentClick();
          }}
          allowOverflow={enableCardSelection}
        >
          <div
            className="thumbnail"
            onMouseEnter={this.handleMouseEnter}
            onMouseLeave={this.handleMouseLeave}
          >
            <HStack
              align="center"
              justify="space-between"
              key={`icon_${resultId}`}
            >
              <Icon as={FaAlignLeft} size={18} color="brand.white" />

              <div onClick={(e) => e.stopPropagation()}>
                {isHovering && (canDeleteAIDocument || isDocumentCreator) ? (
                  <Menu isLazy>
                    <MenuButton
                      as={IconButton}
                      icon={<Icon as={FaEllipsisV} />}
                      variant="ghost"
                      minW="0"
                      h="0"
                      display="flex"
                      sx={{
                        ":focus": {
                          boxShadow: "none",
                        },
                      }}
                    />
                    <MenuList>
                      {showExtraOptions && (
                        <MenuItem
                          icon={<FaArrowAltCircleUp />}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.setState({
                              showMoveToFolderModal: true,
                            });
                          }}
                        >
                          {t("move_to_folder.action")}
                        </MenuItem>
                      )}
                      {showExtraOptions && showRemoveFromFolder && (
                        <MenuItem
                          icon={<FaArrowAltCircleDown />}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.setState({
                              showRemoveFromFolderModal: true,
                            });
                          }}
                        >
                          {t("move_back.action")}
                        </MenuItem>
                      )}
                      <MenuItem
                        icon={<FaTrash />}
                        onClick={(e) => {
                          e.stopPropagation();
                          this.setState({ showConfirmationModal: true });
                        }}
                      >
                        {t("delete", { ns: "common" })}
                      </MenuItem>
                    </MenuList>
                  </Menu>
                ) : null}
              </div>
            </HStack>

            <Divider
              borderColor="brand.border-color"
              borderWidth="1px"
              opacity={1}
              my={4}
              mx={0}
            />
            <Tooltip placement="bottom" hasArrow label={resultName}>
              <div className="title">{resultName}</div>
            </Tooltip>

            <div>
              <div>
                <div className="subtitle" key={`title_${resultId}`}>
                  {result.prompt}
                </div>

                <div className="subtitle" key={`sub_${resultId}`}>
                  {result.last_updated}
                </div>
              </div>

              {!isDocumentCreator && <TldrUserInfoView user={result.creator} />}
            </div>
            {(isHovering || isChecked) &&
            enableCardSelection &&
            canDeleteAIDocument ? (
              <TldrCheckbox
                checked={isChecked}
                onCheck={this.onDocumentClickHandler}
                hasAbsolutePosition
                description={isChecked ? "Unselect" : "Select"}
              />
            ) : null}

            {this.props.selectedCards.length > 0 && (
              <TldrCheckbox
                checked={isChecked}
                onCheck={this.onDocumentClickHandler}
                hasAbsolutePosition
                description={isChecked ? "Unselect" : "Select"}
              />
            )}
          </div>
        </StyledAiRow>

        <TldrConfirmationModal
          modalFor="document"
          inProgress={inProgress}
          show={showConfirmationModal}
          onHide={(e) => {
            this.setState({
              ...this.state,
              showConfirmationModal: false,
            });
          }}
          onYes={() => {
            this.setState(
              {
                inProgress: true,
              },
              this.handleDeleteDocument(resultId)
            );
          }}
        />

        {showMoveToFolderModal ? (
          <div onClick={(e) => e.stopPropagation()}>
            <TldrMoveToFolderModal
              inProgress={inProgress}
              show={showMoveToFolderModal}
              onHide={() => {
                this.setState({
                  showMoveToFolderModal: false,
                });
              }}
              onYes={(folderId, folderName) => {
                this.setState(
                  {
                    inProgress: true,
                  },
                  () => this.handleMoveToFolder(folderId, folderName)
                );
              }}
              onAddFolder={() => {
                this.setState({
                  showNewFolderModal: true,
                  showMoveToFolderModal: false,
                });
              }}
              currentFolderId={currentFolderId}
            />
          </div>
        ) : null}

        {showNewFolderModal ? (
          <TldrNewFolderDialog
            inProgress={inProgress}
            show={showNewFolderModal}
            onHide={() => {
              this.setState({
                showNewFolderModal: false,
              });
            }}
            onYes={(name) => {
              this.setState(
                {
                  inProgress: true,
                },
                () => this.handleCreateNewFolder(name)
              );
            }}
          />
        ) : null}

        {showRemoveFromFolderModal ? (
          <TldrConfirmationModal
            inProgress={inProgress}
            show={showRemoveFromFolderModal}
            customMessage={t("move_back.heading", { name: result.prompt })}
            customBodyMessage={t("move_back.message")}
            customPrimaryActionText={t("move_back_button.text")}
            onHide={() => {
              this.setState({ showRemoveFromFolderModal: false });
            }}
            onYes={() => {
              this.setState(
                {
                  inProgress: true,
                },
                () => this.handleRemoveFromFolder()
              );
            }}
          />
        ) : null}
      </div>
    );
  }

  handleMouseEnter() {
    this.setState({ isHovering: true });
  }

  handleMouseLeave() {
    this.setState({ isHovering: false });
  }

  onDocumentClickHandler = (isChecked) => {
    const { result } = this.props;
    const resultId = result.content_id || result.id;
    const selectedDocument = {
      content_type: ContentTypes.AI_DOCUMENT,
      content_id: resultId,
    };

    if (isChecked) {
      this.props.selectCard(selectedDocument);
    } else {
      this.props.unSelectCard(selectedDocument);
    }
    this.setState({ isChecked });
  };

  handleDeleteDocument = (documentId) => {
    const extraProps = {
      type: "document",
      id: documentId,
    };

    this.setState({
      inProgress: false,
      showConfirmationModal: false,
    });

    this.props.delete(extraProps, this.signal.token).then(() => {
      if (this.props.onActionComplete) {
        this.props.onActionComplete();
      }
    });
  };
}

AIDocument.propTypes = {
  result: PropTypes.object.isRequired,
};

AIDocument.defaultProps = {
  currentFolderId: undefined,
  showRemoveFromFolder: false,
  showExtraOptions: false,
};

const mapStateToProps = (state) => ({
  isPanelShowing: state.folders.isPanelShowing,
  selectedCards: state.folders.selectedCards,
  subscription: state.subscription,
  workspacePermissionChecks: state.permissions.workspacePermissionChecks,
  authUser: state?.auth?.payload?.user,
});

const mapDispatchToProps = (dispatch) => ({
  selectCard: (selectedDoc) => dispatch(selectCard(selectedDoc)),
  unSelectCard: (selectedDoc) => dispatch(unSelectCard(selectedDoc)),
  delete: (props, token) => dispatch(deleteUserAssets(props, token)),
  openAdvancedSettings: (panel, selectedTab, aiPromptId) =>
    dispatch(openAdvancedSettings(panel, selectedTab, aiPromptId)),
  resetDocument: () => dispatch(resetDocument()),
  resetPage: () => dispatch(resetPage()),
  moveToFolder: (payload, folderId, folderName, token) =>
    dispatch(moveToFolder(payload, folderId, folderName, token)),
  createNewFolder: (name, token, props) =>
    dispatch(createNewFolder(name, token, props)),
  getDocuments: (props, search, signal) =>
    dispatch(getDocuments(props, search, signal)),
  removeFolderContent: (folderId, payload, signalToken) =>
    dispatch(removeFolderContent(folderId, payload, signalToken)),
  closeSlider: () => dispatch(closeSlider()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation(["folders"])(AIDocument)));
